<template>
  <van-nav-bar :title="title" left-arrow left-text="返回" @click-left="onClickLeft">
    <template #right>
      <van-icon name="cart" size="30" @click="goIndex()" />
    </template>
  </van-nav-bar>
</template>

<script>
  export default {
    name: 'NavBar',
    props: ['title'],

    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  #NavBar {
    position: fixed;
    top: 0;
    left: 0;
    height: 46px;
    line-height: 46px;
    width: 100%;
    z-index: 100;
  }

  .van-nav-bar {
    font-size: 18px !important;
    /* 设置导航栏的渐变色 */
    background: linear-gradient(to right, #1750eb, #fe6e49) !important;
    background: -webkit-linear-gradient(to right, #1750eb, #fe6e49) !important;
    border: 0;
  }

  .van-hairline--bottom::after {
    /* 去除导航栏底部的白色横线 */
    border-bottom-width: 0px !important;
  }
</style>